import { ViteReactSSG } from 'vite-react-ssg'
import '@/i18n/config'
import './index.css'
import { RootLayout } from '@/components/RootLayout'
import App from './App'
import { Impressum } from '@/pages/Impressum'
import { Datenschutz } from '@/pages/Datenschutz'

const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: '/', element: <App /> },
      { path: '/legal-notice', element: <Impressum /> },
      { path: '/privacy-policy', element: <Datenschutz /> },
    ],
  },
]

export const createRoot = ViteReactSSG({ routes })
